import { useState } from "react";
import { GlassCard, SectionHeader } from "./ui";
import { fmtDate } from "./utils";

export function AnnouncementsSection({ announcements, loading }) {
  const [selected, setSelected] = useState(null);
  // Sem anúncios a secção não aparece (nem no menu).
  if (!loading && !(announcements || []).length) return null;

  return (
    <section id="anuncios" className="public-section public-announcements-section py-10 sm:py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader
          k="Anúncios"
          title="Novidades da comunidade"
          desc="Informações importantes e actividades para toda a comunidade."
          right={
            <a href="#contactos" className="text-sm font-semibold text-indigo-700 dark:text-indigo-300 hover:text-indigo-500 dark:hover:text-indigo-300">
              Ver contactos
            </a>
          }
        />

        {loading ? (
          <div className="public-announcements-grid grid gap-4 sm:grid-cols-2">
            {Array.from({ length: 4 }).map((_, idx) => (
              <GlassCard key={`ann-skeleton-${idx}`} className="p-5 animate-pulse">
                <div className="flex items-start gap-4">
                  <div className="h-12 w-12 rounded-2xl bg-slate-200 dark:bg-slate-700" />
                  <div className="min-w-0 flex-1">
                    <div className="h-5 w-2/3 rounded bg-slate-200 dark:bg-slate-700 mb-2" />
                    <div className="h-4 w-full rounded bg-slate-200 dark:bg-slate-700 mb-2" />
                    <div className="h-4 w-4/5 rounded bg-slate-200 dark:bg-slate-700" />
                  </div>
                </div>
              </GlassCard>
            ))}
          </div>
        ) : announcements && announcements.length > 0 ? (
          <div className="public-announcements-grid grid gap-4 sm:grid-cols-2">
            {announcements.slice(0, 6).map((a, idx) => (
              <GlassCard key={a.id || idx} className="p-5 hover:shadow-md transition">
                <div className="flex items-start gap-4">
                  <div className="shrink-0 h-12 w-12 rounded-2xl bg-indigo-50 dark:bg-indigo-950/40 text-indigo-700 dark:text-indigo-300 font-bold flex items-center justify-center text-center text-xs leading-tight">
                    {fmtDate(a.date).slice(0, 5)}
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="mb-2 flex flex-wrap items-center gap-2">
                      <span className="rounded-full bg-amber-50 dark:bg-amber-950/40 px-2.5 py-1 text-[11px] font-bold text-amber-800 dark:text-amber-300">
                        {a.category || "Comunicado"}
                      </span>
                      <span className="text-xs text-slate-500 dark:text-slate-400">{fmtDate(a.date)}</span>
                    </div>
                    <div className="font-semibold text-slate-900 dark:text-slate-100">{a.title}</div>
                    <div className="text-sm text-slate-600 dark:text-slate-400 mt-1">{a.description}</div>
                    <button
                      type="button"
                      onClick={() => setSelected(a)}
                      className="mt-3 inline-flex items-center text-sm font-semibold text-indigo-700 dark:text-indigo-300 hover:text-indigo-500 dark:hover:text-indigo-300"
                    >
                      Ler anúncio <span aria-hidden="true" className="ml-1">→</span>
                    </button>
                  </div>
                </div>
              </GlassCard>
            ))}
          </div>
        ) : null}
      </div>

      {selected ? (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/45 p-4" role="dialog" aria-modal="true" aria-labelledby="public-announcement-title">
          <div className="w-full max-w-2xl rounded-3xl border border-white dark:border-slate-900/70 bg-white dark:bg-slate-900 p-6 shadow-2xl sm:p-8">
            <div className="flex items-start justify-between gap-4">
              <div>
                <span className="inline-flex rounded-full bg-amber-50 dark:bg-amber-950/40 px-2.5 py-1 text-xs font-bold text-amber-800 dark:text-amber-300">{selected.category || "Comunicado"}</span>
                <h3 id="public-announcement-title" className="mt-3 text-2xl font-extrabold tracking-tight text-slate-900 dark:text-slate-100">{selected.title}</h3>
                <div className="mt-1 text-sm text-slate-500 dark:text-slate-400">Publicado em {fmtDate(selected.date)}</div>
              </div>
              <button type="button" onClick={() => setSelected(null)} aria-label="Fechar anúncio" className="rounded-xl px-3 py-2 text-xl text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800">×</button>
            </div>
            <p className="mt-6 whitespace-pre-line leading-relaxed text-slate-700 dark:text-slate-300">{selected.description}</p>
            <div className="mt-7 flex justify-end">
              <button type="button" onClick={() => setSelected(null)} className="rounded-full bg-slate-950 px-5 py-2.5 font-semibold text-white hover:bg-indigo-700">Fechar</button>
            </div>
          </div>
        </div>
      ) : null}
    </section>
  );
}
